"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _two = _interopRequireDefault(require("@/components/upload/two.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter.vue"));
var _index2 = _interopRequireDefault(require("@/components/selPlat/index.vue"));
var _utils = require("@/utils");
var _auth = require("@/utils/auth");
var _editwith = _interopRequireDefault(require("../agent/_editwith.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'agent',
  components: {
    upload: _two.default,
    Pagination: _index.default,
    drawer: _filter.default,
    selPlat: _index2.default,
    editwith: _editwith.default
  },
  props: {
    user_type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    var _this = this;
    return {
      sort_type: [{
        name: '综合排序',
        value: 0
      }, {
        name: '收益从高到低',
        value: 1
      }, {
        name: '收益从低到高',
        value: 2
      }, {
        name: '创建时间由近到远',
        value: 3
      }, {
        name: '创建时间由远到近',
        value: 4
      }],
      form: {},
      give_role: [],
      tableMaxH: '250',
      list: [],
      put_place: [],
      listLoading: true,
      listQuery: {
        activated_status: 1,
        search_agent_id: '0',
        sort_type: '0',
        search_agent_level: '0',
        put_place: '',
        son_type: 0,
        start: 1,
        limit: 10,
        page_num: 1
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      monthOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.month_date) {
            return time.getTime() < _this.form.month_date || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      zuo_sn: '',
      selSnArr: [],
      // 提现费率
      withdrawObj: {},
      withdrawDialog: false,
      isSyqkDialog: false,
      isSyqkObj: {},
      // 提现手续费
      withdrawFeeObj: {},
      withdrawFeeDialog: false,
      // 提现手续费
      isFrozenObj: {},
      isFrozenDialog: false,
      //余额增值
      isYezzObj: {},
      isYezzDialog: false,
      //平台补贴比例设置
      balanceSetObj: {},
      banlanceSetDialog: false,
      // 免费店员
      freeObj: {},
      freeDialog: false,
      iconDialog: false,
      brand_icon: {},
      // 余额总览
      overviewDialogVisible: false,
      // 显示余额总览
      chartInstance: null,
      // 折线图实例
      rechargeChartInstance: null,
      // 充值柱状图实例
      loadingOverviewData: false,
      // 加载中
      loadingRechargeData: false,
      // 充值图表加载中
      // 显示数据统计的账号角色
      explanationContentTitle: '二级代理账号',
      // 展示用户清零余额说明信息
      explanationUserClearAmount: false,
      // 充值图表相关数据
      rechargeDateRange: [],
      // 时间范围
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == "agentEdit") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated: function activated() {
    this.zuo_sn = this.$route.query.zuo_sn || '';
    if (!this.$route.meta.isBack || !this.list) {
      this.getPower();
      this.toQuery();
    }
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {
    this.showDialog(); // 显示余额总览
    this.toQuery(); // 获取代理用户信息列表
  },
  methods: {
    /**
     * 获取权限
     */
    getPower: function getPower() {
      var _this2 = this;
      var give_role = [{
        role_name: '全部',
        role_id: 0
      }];
      this.$get('agentapi/add_agent').then(function (res) {
        _this2.give_role = give_role.concat(res.give_role_right);
        _this2.put_place = res.put_place;
      });
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery = {
          activated_status: 1,
          search_agent_id: '0',
          sort_type: '0',
          search_agent_level: '0',
          put_place: '',
          son_type: 0,
          start: 1,
          limit: 10,
          page_num: 1
        };
      }
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取代理用户信息列表
     */
    getList: function getList() {
      var _this3 = this;
      this.listQuery.son_type = this.user_type;
      var url = 'agentapi/sttuf/agent_list_all';
      var listQuery = Object.assign(this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      if (listQuery.month_date) listQuery.month_date = this.parseTime(listQuery.month_date, '{y}-{m}');
      this.$get(url, listQuery).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.list;
        _this3.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this3.tableMaxH = window.innerHeight - _this3.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    /**
     *  设备
     * @returns {string}
     */
    device: function device() {
      return this.$store.state.app.device;
    },
    /**
     * 显示对应代理的存量余额详情
     */
    showBalanceDetail: function showBalanceDetail(rowData) {
      var _this4 = this;
      // 这里可以处理 rowData 数据，调用总览查询方法
      var param = {
        query_aid: rowData.aid,
        role_id: rowData.role_id,
        role_name: rowData.role_name,
        agent_level: rowData.agent_level,
        agent_name: rowData.agent_name
      };
      this.overviewDialogVisible = true; // 显示对话框
      this.loadingOverviewData = true; // 设置加载状态为true
      this.initRechargeDateRange(); // 初始化充值图表时间范围
      this.$nextTick(function () {
        _this4.fetchOverviewData(rowData.name, param);
        _this4.fetchRechargeData(param); // 获取充值数据
      });
    },
    /**
     * 余额总览 - 显示对话框
     */
    showDialog: function showDialog() {
      var _this5 = this;
      this.overviewDialogVisible = true; // 显示对话框
      this.loadingOverviewData = true; // 设置加载状态为true
      this.initRechargeDateRange(); // 初始化充值图表时间范围
      this.$nextTick(function () {
        _this5.fetchOverviewData();
        _this5.fetchRechargeData(); // 获取充值数据
      });
    },
    /**
     * 初始化充值图表时间范围（默认今日）
     */
    initRechargeDateRange: function initRechargeDateRange() {
      var today = new Date();
      var yyyy = today.getFullYear();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var dd = String(today.getDate()).padStart(2, '0');
      var todayStr = "".concat(yyyy, "-").concat(mm, "-").concat(dd);
      this.rechargeDateRange = [todayStr, todayStr];
    },
    /**
     * 处理日期变化
     */
    handleDateChange: function handleDateChange(value) {
      this.rechargeDateRange = value;
    },
    /**
     * 刷新充值图表
     */
    refreshRechargeChart: function refreshRechargeChart() {
      this.fetchRechargeData();
    },
    /**
     * 获取存量余额数据并初始化图表
     */
    fetchRechargeData: function fetchRechargeData() {
      var _this6 = this;
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.loadingRechargeData = true;

      // 构造查询日期范围
      var query_date = "";
      if (this.rechargeDateRange && this.rechargeDateRange.length === 2) {
        query_date = "".concat(this.rechargeDateRange[0], " 00:00:01|").concat(this.rechargeDateRange[1], " 23:59:59");
      } else {
        // 默认查询今日
        var today = new Date();
        var yyyy = today.getFullYear();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var dd = String(today.getDate()).padStart(2, '0');
        var todayStr = "".concat(yyyy, "-").concat(mm, "-").concat(dd);
        query_date = "".concat(todayStr, " 00:00:01|").concat(todayStr, " 23:59:59");
      }

      // 调用后端接口获取数据
      this.$get('agentapi/data_overview/project_amount_consumption', _objectSpread({
        query_date: query_date
      }, param)).then(function (res) {
        _this6.initRechargeChartWithData(res);
      }).catch(function (err) {
        console.error("err==>", err);
        _this6.$message.error('获取充值数据失败，请稍后重试');
      }).finally(function () {
        _this6.loadingRechargeData = false;
      });
    },
    /**
     * 初始化充值图表
     */
    initRechargeChartWithData: function initRechargeChartWithData(data) {
      var echarts = require('echarts');

      // 销毁已有的图表实例
      if (this.rechargeChartInstance) {
        this.rechargeChartInstance.dispose();
      }

      // 初始化图表实例
      this.rechargeChartInstance = echarts.init(this.$refs.rechargeChartContainer);

      // 默认数据
      var projectTypes = ['充电宝', '充电线', '充电桩', '套套机'];
      var rechargeData = [0, 0, 0, 0];

      // 处理返回的数据
      if (data) {
        // 检查 data 是否为数组，如果不是则转换为数组
        var dataArray = Array.isArray(data) ? data : Object.values(data);
        dataArray.forEach(function (item) {
          // 根据 project_type 确定数据应该放在哪个位置
          // project_type: 0-充电宝, 1-充电线, 3-充电桩, 7-套套机
          switch (item.project_type) {
            case 0:
              // 充电宝
              rechargeData[0] = parseFloat(item.balance_money) || 0;
              break;
            case 1:
              // 充电线
              rechargeData[1] = parseFloat(item.balance_money) || 0;
              break;
            case 3:
              // 充电桩
              rechargeData[2] = parseFloat(item.balance_money) || 0;
              break;
            case 7:
              // 套套机
              rechargeData[3] = parseFloat(item.balance_money) || 0;
              break;
          }
        });
      }

      // 构建图表配置项
      var option = {
        title: {
          text: '各项目存量余额',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var param = params[0];
            return "".concat(param.name, "<br/>").concat(param.marker).concat(param.value, "\u5143");
          }
        },
        xAxis: {
          type: 'category',
          data: projectTypes
        },
        yAxis: {
          type: 'value',
          name: '金额 (元)'
        },
        series: [{
          data: rechargeData,
          type: 'bar',
          barWidth: '50%',
          barMinHeight: 2,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#83bff6'
            }, {
              offset: 0.5,
              color: '#188df0'
            }, {
              offset: 1,
              color: '#188df0'
            }])
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, "\u5143");
            }
          }
        }]
      };
      this.rechargeChartInstance.setOption(option);
    },
    /**
     * 通过接口读取数据并初始化图表内容
     */
    fetchOverviewData: function fetchOverviewData() {
      var _this7 = this;
      var titleTextName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.explanationUserClearAmount = false;
      this.explanationContentTitle = param.role_name === '' ? '代理' : param.role_name + '名';
      // 调用后端接口获取数据
      this.$get('agentapi/data_overview/overview_existing_amount', param).then(function (res) {
        // 假设返回的数据格式为 { deposit: 12000, agent: 15000, merchant: 8000, promotion: 10000 }
        _this7.initChartWithData(res, titleTextName);
      }).catch(function (err) {
        // 弹窗提示
        _this7.$message.error('获取总览数据失败，请稍后重试');
      }).finally(function () {
        _this7.loadingOverviewData = false; // 设置加载状态为false
      });
    },
    /**
     * 初始化图表
     * @param data
     */
    initChartWithData: function initChartWithData(data) {
      var titleTextName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var echarts = require('echarts');
      // 销毁已有的图表实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      // 初始化图表实例
      this.chartInstance = echarts.init(this.$refs.chartContainer);

      // 计算各项金额
      var userDepositAmount = data.user_deposit_amount || 0; // 用户-押金余额
      var userBalanceAmount = data.user_balance_amount || 0; // 用户-钱包余额
      var userClearAmount = data.user_clear_amount || 0; // 用户-清零金额
      var agentAmount = data.agent_amount || 0; // 代理余额
      var merchantAmount = data.merchant_amount || 0; // 商户余额
      var promotionAmount = data.promotion_amount || 0; // 推广余额
      var partnerAmount = data.partner_amount || 0; // 合伙人余额
      var salesmanAmount = data.salesman_amount || 0; // 业务员余额
      var withdrawAmount = data.withdraw_amount || 0; // 用户提现待审核的余额
      var total = data.total_amount || 0; // 总额
      var titleText = titleTextName === '' ? "各类存量余额总览" : titleTextName + "-存量余额总览";

      // 计算百分比
      var percentages = [{
        name: '用户押金余额',
        percentage: total ? (userDepositAmount / total * 100).toFixed(2) : 0
      }, {
        name: '用户钱包余额',
        percentage: total ? (userBalanceAmount / total * 100).toFixed(2) : 0
      }, {
        name: '用户提现待审核',
        percentage: total ? (withdrawAmount / total * 100).toFixed(2) : 0
      }, {
        name: '代理余额',
        percentage: total ? (agentAmount / total * 100).toFixed(2) : 0
      }, {
        name: '商户余额',
        percentage: total ? (merchantAmount / total * 100).toFixed(2) : 0
      }, {
        name: '业务员余额',
        percentage: total ? (salesmanAmount / total * 100).toFixed(2) : 0
      }, {
        name: '推广余额',
        percentage: total ? (promotionAmount / total * 100).toFixed(2) : 0
      }];
      // 构建 x 轴数据
      var xAxisData = ["\u7528\u6237\u62BC\u91D1\u4F59\u989D\n\n".concat(percentages[0].percentage, "%"), "\u7528\u6237\u94B1\u5305\u4F59\u989D\n\n".concat(percentages[1].percentage, "%"), "\u7528\u6237\u63D0\u73B0\u5F85\u5BA1\u6838\n\n".concat(percentages[2].percentage, "%"), "\u4EE3\u7406\u4F59\u989D\n\n".concat(percentages[3].percentage, "%"), "\u5546\u6237\u4F59\u989D\n\n".concat(percentages[4].percentage, "%"), "\u4E1A\u52A1\u5458\u4F59\u989D\n\n".concat(percentages[5].percentage, "%"), "\u63A8\u5E7F\u4F59\u989D\n\n".concat(percentages[6].percentage, "%")];
      // 构建 series 数据
      var seriesData = [userDepositAmount, userBalanceAmount, withdrawAmount, agentAmount, merchantAmount, salesmanAmount, promotionAmount];
      // 如果 data为空的，就在percentages 追加一列合伙人和用户清零金额 的 数据上去
      if (titleTextName === '') {
        this.explanationContentTitle = "平台";
        // 合伙人的
        percentages.push({
          name: '合伙人余额',
          percentage: total ? (partnerAmount / total * 100).toFixed(2) : 0
        });
        xAxisData.push("\u5408\u4F19\u4EBA\u4F59\u989D\n\n".concat(percentages[6].percentage, "%"));
        seriesData.push(partnerAmount);
        // 判断用户的清零金额是否需要展示出来.
        if ('user_clear_amount' in data && data.user_clear_amount !== undefined) {
          this.explanationUserClearAmount = true;
          // 用户清零（增值的）
          percentages.push({
            name: '用户增值金额',
            percentage: total ? (userClearAmount / total * 100).toFixed(2) : 0
          });
          xAxisData.push("\u7528\u6237\u589E\u503C\u91D1\u989D\n\n".concat(percentages[7].percentage, "%"));
          seriesData.push(userClearAmount);
        }
      }

      // 构建图表配置项
      var option = {
        title: [{
          text: titleText,
          left: 'center'
        }, {
          text: '总额: ' + total + '元',
          right: 20,
          top: 20,
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#333'
          }
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var param = params[0];
            var percentage = percentages[param.dataIndex].percentage;
            return "".concat(param.name, "<br/>").concat(param.marker).concat(param.value, "\u5143<br/>\u5360\u6BD4: ").concat(percentage, "%");
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          name: '金额 (元)'
        },
        series: [{
          data: seriesData,
          type: 'bar',
          barWidth: '50%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#83bff6'
            }, {
              offset: 0.5,
              color: '#188df0'
            }, {
              offset: 1,
              color: '#188df0'
            }])
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, "\u5143");
            }
          }
        }]
      };
      this.chartInstance.setOption(option);
    },
    /**
     * 关闭对话框
     * @param done
     */
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    }
  }
};